import { Title } from "@mantine/core";
import { L2KH4Props } from "./types";
import { H4_STYLE, COLORS } from "./constants";

/**
 * L2KH4 - Fourth level heading component
 * Renders as <h4> by default, uses Big Shoulders Display font
 * Responsive sizing: 22px → 28px across 320px → 1920px viewports
 */
export function L2KH4({
  children,
  variant = "primary",
  component = "h4",
  style,
  ...props
}: L2KH4Props) {
  return (
    <Title
      order={4}
      component={component}
      style={{
        fontSize: H4_STYLE.fontSize,
        lineHeight: H4_STYLE.lineHeight,
        letterSpacing: H4_STYLE.letterSpacing,
        fontWeight: H4_STYLE.fontWeight,
        fontFamily: H4_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
